/* 
This file is not being used. 
Created for R&D , was being used in PrivateRoute.js 
*/

import Loadable from "react-loadable";
import PageLoader from "../components/PageLoader";
import { app_path } from "config";

const sitePrefix = `${app_path}/`;
const loadables = {
  Accounts: Loadable({
    loader: () => import("../modules/Accounts/Profile"),
    loading: PageLoader,
  }),
  Recharge: Loadable({
    loader: () => import("../modules/Recharge"),
    loading: PageLoader,
  }),
  // SendVoucherLanding		: Loadable({loader: () => import("../modules/CreateSendVoucher"), loading: PageLoader}),

  EmpulsReport: Loadable({
    loader: () => import("../modules/Reports/EmpulsReport"),
    loading: PageLoader,
  }),
  GenerateBrandVoucher: Loadable({
    loader: () => import("../modules/ClientDashboard/GenerateBrandVoucher"),
    loading: PageLoader,
  }),

  ListingBrandVouchers: Loadable({
    loader: () => import("../modules/ClientDashboard/ListingBrandVouchers"),
    loading: PageLoader,
  }),
  VoucherRecharge: Loadable({
    loader: () => import("../modules/Reports/VoucherRecharge"),
    loading: PageLoader,
  }),

  PlumProReport: Loadable({
    loader: () => import("../modules/Reports/PlumProReport"),
    loading: PageLoader,
  }),

  Report: Loadable({
    loader: () => import("../modules/Reports"),
    loading: PageLoader,
  }),
  PerksReport: Loadable({
    loader: () => import("../modules/Reports/PerksReport"),
    loading: PageLoader,
  }),

  PlumPoints: Loadable({
    loader: () => import("../modules/PlumPoints"),
    loading: PageLoader,
  }),

  BulkUpload: Loadable({
    loader: () => import("../components/BulkUpload"),
    loading: PageLoader,
  }),
  Campaign: Loadable({
    loader: () => import("../modules/Campaign"),
    loading: PageLoader,
  }),

  Wallet: Loadable({
    loader: () => import("../modules/Wallet"),
    loading: PageLoader,
  }),

  XoxoTokenReport: Loadable({
    loader: () => import("../modules/Reports/XoxoTokenReports"),
    loading: PageLoader,
  }),
  XoxoLink: Loadable({
    loader: () => import("../modules/XoxoLink"),
    loading: PageLoader,
  }),

  XoxoLink: Loadable({
    loader: () => import("../modules/XoxoLink"),
    loading: PageLoader,
  }),
  Integrations: Loadable({
    loader: () => import("../modules/Integrations"),
    loading: PageLoader,
  }),
  EmailPreviewScreen: Loadable({
    loader: () => import("../modules/EmailPreviewScreen/emailPreviewIndex"),
    loading: PageLoader,
  }),
  XoxolinkEmailPreview: Loadable({
    loader: () => import("../modules/EmailPreviewScreen/xoxolinkEmailPreview"),
    loading: PageLoader,
  }),
  IntegrationsDashboard: Loadable({
    loader: () => import("../modules/IntegrationsDashboard"),
    loading: PageLoader,
  }),
  SapSuccessfactors: Loadable({
    loader: () => import("../modules/SapSuccessfactors"),
    loading: PageLoader,
  }),
};

export default {
  loadables: loadables,
  routes: {
    Accounts: {
      component: loadables.Accounts,
      path: `/${sitePrefix}accounts`,
      moduleId: 1,
    },
    CreateXoxoVoucher: {
      component: loadables.CreateXoxoVoucher,
      path: `/${sitePrefix}xoxo-code/`,
      name: " My Account Login",
    },
    Recharge: {
      component: loadables.Recharge,
      path: `/${sitePrefix}recharge/`,
      name: " My Account Dashboard",
    },

    // CreateLanding : {
    //     component   : loadables.CreateLanding,
    //     path        : `/${sitePrefix}/logout`,
    //     exact       : true,
    //     name        : ' My Account Dashboard'
    // },
    GenerateBrandVoucher: {
      component: loadables.GenerateBrandVoucher,
      path: `/${sitePrefix}generate-brand-voucher/`,
      name: "generate voucher",
    },
    ListingBrandVouchers: {
      component: loadables.ListingBrandVouchers,
      path: `/${sitePrefix}listing-brand-vouchers/`,
      name: " My Account Dashboard",
    },

    VoucherRecharge: {
      component: loadables.VoucherRecharge,
      path: `/${sitePrefix}reports/voucher-recharge/`,
      name: " My Account Dashboard",
    },
    PlumProReport: {
      component: loadables.PlumProReport,
      path: `/${sitePrefix}reports/plum-pro-report/`,
      name: " My Account Dashboard",
    },
    Report: {
      component: loadables.Report,
      path: `/${sitePrefix}reports/`,
      name: " My Account Dashboard",
    },
    PerksReport: {
      component: loadables.PerksReport,
      path: `/${sitePrefix}reports/perks-report/`,
      name: " My Account Dashboard",
    },

    PlumPoints: {
      component: loadables.PlumPoints,
      path: `/${sitePrefix}xoxo-points/`,
      name: " My Account Dashboard",
    },
    BulkUpload: {
      component: loadables.BulkUpload,
      path: `/${sitePrefix}bulkupload/`,
      name: " My Account Dashboard",
    },
    Campaign: {
      component: loadables.Campaign,
      path: `/${sitePrefix}campaign/`,
      name: " compaign",
    },
    Wallet: {
      component: loadables.Wallet,
      path: `/${sitePrefix}wallet/`,
      name: " wallet",
    },
    XoxoTokenReport: {
      component: loadables.XoxoTokenReport,
      path: `/${sitePrefix}reports/xoxo-token-report/`,
      name: " Xoxotoken Report",
    },
    XoxoLink: {
      component: loadables.XoxoLink,
      path: `/${sitePrefix}xoxo-link/`,
      name: " Xoxo Link",
    },
    SurveyAutomation: {
      component: loadables.SurveyAutomation,
      path: `/${sitePrefix}survey-monkey/surveyAutomation/`,
      name: " My Account Dashboard",
    },
    EmailPreviewScreen: {
      component: loadables.EmailPreviewScreen,
      path: `/${sitePrefix}xoxo-voucher/email-preview-screen/`,
      name: " My Account Dashboard",
    },
    XoxolinkEmailPreview: {
      component: loadables.XoxolinkEmailPreview,
      path: `/${sitePrefix}xoxo-link/email-preview-screen/`,
      name: " My Account Dashboard",
    },
    IntegrationsDashboard: {
      component: loadables.IntegrationsDashboard,
      path: `/${sitePrefix}integration-dashboard/`,
      name: " Integrations Dashboard",
    },
  },
};
